/**
 * Raw font-scale tokens. No MUI imports.
 * Referenced by createAppTheme.ts to build the MUI typography config.
 *
 * FIGMA reference:
 *  https://www.figma.com/design/CqO24eewdxuBg3MkLbj2QX/BHB-components?node-id=6112-51415&t=cqV7qec26xmWuSV7-0
 */

export enum FontWeight {
  regular = 400,
  medium = 500,
  semiBold = 600,
  bold = 700
}

export enum FontSize {
  xs = "11px",
  sm = "12px",
  md = "13px",
  base = "14px",
  lg = "16px",
  xl = "18px",
  xl2 = "20px",
  xl3 = "24px",
  xl4 = "28px",
  xl5 = "32px"
}

/**
 * Variant definitions consumed directly by createAppTheme.ts.
 * Each key maps to a custom MUI variant declared in types.d.ts.
 */
export const typographyVariants = {
  headline: {
    fontSize: FontSize.xl3,
    fontWeight: FontWeight.regular
  },
  title1: {
    fontSize: FontSize.xl2,
    fontWeight: FontWeight.medium
  },
  title2: {
    fontSize: FontSize.xl2,
    fontWeight: FontWeight.regular
  },
  body3: {
    fontSize: FontSize.lg,
    fontWeight: FontWeight.regular
  },
  body4: {
    fontSize: FontSize.base,
    fontWeight: FontWeight.medium
  },

  // v2 additions
  /** Small caps label — form field labels, table headers */
  label: {
    fontSize: FontSize.sm,
    fontWeight: FontWeight.semiBold,
    letterSpacing: "0.08em",
    textTransform: "uppercase" as const
  },
  /** Helper / caption — below inputs, in tooltips */
  helper: {
    fontSize: FontSize.xs,
    fontWeight: FontWeight.regular,
    lineHeight: 1.5
  }
} as const;
